import React from 'react';
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import MobileNetworks from './MobileNetworks.json';
import {Alert, Badge} from 'reactstrap';
import {RequestStatus} from '../../common/Constants';
import Icon from "react-icons-kit";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import SmartDialog from "../../components/SmartDialog";
import {DateRangePicker} from "react-dates";

import {ic_date_range} from 'react-icons-kit/md/ic_date_range';
import {ic_view_day} from 'react-icons-kit/md/ic_view_day';
import {ic_view_week} from 'react-icons-kit/md/ic_view_week';

const Sectors = [
    { text: "Northern Kenya" , value: "north" },
    { text: "Southern Kenya", value: "south" }
];

export class TimeRangeSelectionDialog extends React.Component{

    static propTypes = {
        onSelect: PropTypes.func,
        from: PropTypes.object,
        to: PropTypes.object,
        onApply: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = TimeRangeSelectionDialog.getInitialState();
    }

    static getInitialState(state = {}){

        return {
            start: state.start || null,
            end: state.end || null,
            focusedInput: null,
        }

    }

    show({ start , end }){

        return this.setState(TimeRangeSelectionDialog.getInitialState({
            start,
            end
        }),() =>{
            this._dlg.show();
        });
    }

    toggle(){
        return this._dlg.toggle();
    }


    handleSelect({ startDate , endDate }){

        this.setState({
            start: startDate,
            end: endDate
        });

    }

    handleApply(){

        const start = this.state.start;
        const end = this.state.end;
        if(_.isFunction(this.props.onApply) && moment(start).isValid() && moment(end).isValid()){
            this.props.onApply({ start, end });
        }

    }

    render(){

        const { start , end } = this.state;
        return <SmartDialog ref={r => this._dlg = r} title={"Choose Date Range"} onExit={() => this.handleApply()}>
            <p>Select custom time range to display</p>

            <DateRangePicker startDate={start}
                             startDateId="range_start"
                             endDate={end}
                             showClearDates
                             enableOutsideDays
                             isDayBlocked={() => false}
                             isOutsideRange={() => false}
                             focusedInput={this.state.focusedInput}
                             onFocusChange={focusedInput => this.setState({ focusedInput })}
                             endDateId="range_end"
                             onDatesChange={this.handleSelect.bind(this)}/>
        </SmartDialog>
    }

}

function detectPhoneOperator(phone) {

    const network = MobileNetworks.find(x => {
        if(x.prefixes.find(t => phone.startsWith(t))){
            return true;
        }
    });

    if(network){
        return network.name;
    }

    return "Vodafone";
}

function isTokenRequired(network) {

    const n = MobileNetworks.find(x => x.name == network);
    if(n){
        return n.requireToken;
    }

    return false;
}

function computeServiceCost(formRenderer , services) {

    if(formRenderer) {

        const v  = formRenderer.getInputValueWithName("hectares");
        const sector = formRenderer.getInputValueWithName("sector");

        if(v > 0) {
            const selService = formRenderer.getInputValueWithName("service");
            const svc = services.find(x => x.id == selService);
            return svc.cost_segmentation[sector] * v;
        }
    }

}


function renderStatus(request, onClick ) {

    let content;
    switch (request.status){
        case RequestStatus.Completed:
            content = <Badge pill={true}>Complete</Badge>;
            break;
        case RequestStatus.Assigned:
            content = <Badge pill={true} color={"success"}>Assigned</Badge>;
            break;
        case RequestStatus.Unassigned:
            content = <Badge pill={true} color={"warning"}>Unassigned</Badge>;
            break;
        case RequestStatus.Cancelled:
            content = <Badge pill={true} color={"danger"}>Cancelled</Badge>;
            break;
    }

    return <h6 onClick={onClick} style={ onClick ? { cursor: "pointer"}  : null }>{content}</h6>;
}


export const FarmerInfoInputs = ({  farmers }) => {

    let personalInfo;
    if(Array.isArray(farmers) && farmers.length > 0){

        personalInfo = [
            { name: 'farmer' , type: 'dropdown' , title: 'Farmer' , hint: 'Select your farmer...' , icon : 'fa fa-user' , required: true , items: farmers.map(m => {
                    return { text: m.name, value: m.id }
                })},
            { name: 'operator' , title: 'Mobile Network Operator' , type: 'select' , hint: "Select the network operator for the farmer's phone number", items: MobileNetworks.map(m =>{
                    return { text: m.name , value: m.name };
            }) , required: true , defaultValue: MobileNetworks[0].name }
        ];

    }
    else {

        personalInfo = [
            { name: 'name' , type: 'text' , title: 'Name' , hint: 'Enter the name of the farmer...' , icon : 'fa fa-user' , required: true },
            { name: 'phone'  , type: 'phone' , title: 'Phone' , hint: "Enter the farmer's phone number" , icon: 'fa fa-phone' , required: true },
            { name: 'operator' , title: 'Mobile Network Operator' , type: 'select' , hint: 'Select the network operator for the phone number', items: MobileNetworks.map(m =>{
                    return { text: m.name , value: m.name };
            }) , required: true , defaultValue: MobileNetworks[0].name }
        ];

    }

    return personalInfo;
};



/**
 * Renders tractor request form
 * @param formRenderer The form renderer used to render the inputs
 * @param services The available USSD services
 * @param refreshCallback The callback for refreshing the host component
 * @param {Object} opts
 */
function renderInputs(formRenderer,services,refreshCallback , opts) {

    opts = opts || {};
    const sections = opts.sections || {
        service: true,
        farmerInfo: true,
        payment: true
    };

    const farmers = opts.farmers;

    let paymentInfo = [
        { name: 'txn_phone' , title: 'Phone Number' , type: 'phone' , hint: 'Enter the phone number you wish to pay request with here...' , required: true },
        { name: 'txn_operator' , title: 'Network' , type: 'select' , hint: 'Select the network operator for the phone number', items: MobileNetworks.map(m =>{
            return { text: m.name , value: m.name };
        }) , required: true , onChange: () => {

            if(refreshCallback)
                refreshCallback();

        }}
    ];

    if(!formRenderer ? MobileNetworks[0].requireToken :  isTokenRequired(formRenderer.getInputValueWithName("txn_operator"))) {
        paymentInfo = paymentInfo.concat({ name: 'token' , title: 'Token' , type: 'text' , hint: 'Enter wallet confirmation token here' , required: true });
    }


    let personalInfo;
    if(farmers){

        personalInfo = [
            { name: 'farmer' , type: 'dropdown' , title: 'Farmer' , hint: 'Select your farmer...' , icon : 'fa fa-user' , required: true , items: farmers.map(m => {
                return { text: m.name, value: m.id }
            })},
            { name: 'operator' , title: 'Mobile Network' , type: 'select' , hint: "Select the network operator for the farmer's phone number", items: MobileNetworks.map(m =>{
                return { text: m.name , value: m.name };
            }) , required: true }
        ];

    }
    else {

        personalInfo = [
            { name: 'name' , type: 'text' , title: 'Name' , hint: 'Enter the name of the farmer...' , icon : 'fa fa-user' , required: true },
            { name: 'phone'  , type: 'phone' , title: 'Phone' , hint: "Enter the farmer's phone number" , icon: 'fa fa-phone' , required: true },
            { name: 'operator' , title: 'Network' , type: 'select' , hint: 'Select the network operator for the phone number', items: MobileNetworks.map(m =>{
                return { text: m.name , value: m.name };
            }) , required: true }
        ];

    }

    return [
        {
            render: (key) => {

                const cost = computeServiceCost(formRenderer , services);
                if(cost !== undefined){
                    return (<Alert key={key} className="fade fadeIn">Estimated Cost:  GH¢ <b>{cost}</b></Alert>);
                }

            }
        },

        //  ****************
        //  Hidden inputs
        //  ****************
        {
            name: "cost" ,
            type: "hidden",
            style: { display: "none" },
            getInputValue: (name,ref) => {
                return computeServiceCost(formRenderer,services);
            }
        },
        //  *****************
        {

           group: [
               { name: 'sector' , title: <b>Region/Sector</b> , type: 'select' , items: Sectors, onChange: () => refreshCallback ? refreshCallback() : null  }
           ],

           render: (content,key) => {
               return <div key={key}>
                   {content}
                   <hr/>
               </div>
           }

        },
        {
            group: [
                { name: 'service' , title: 'Service Type' , type: 'dropdown' ,  items: !services ?  [] : services.map(x => {
                    return { text: x.name , value : x.id  }
                }) , onChange: () => refreshCallback ? refreshCallback() : null , required: true },
                { name: 'hectares' , title: 'Total Hectare(s)', type: 'number' , hint: 'Enter desired service hectares...' , onChange: () => refreshCallback ? refreshCallback() : null , required: true , min: 1 },
                { name: 'location', title: 'Location' , type: 'location' , hint: 'Enter the location...' , icon : 'fa fa-map-marker' , coord: {
                    lat: 'location_lat',
                    lng: 'location_long'
                }, required: true }
            ],

            render: (content,key) => {
                return <DialogCollapseSection title={"Service"} key={key} initiallyOpen={sections.service}>
                    {content}
                </DialogCollapseSection>
            }

        },
        {
            group: personalInfo,

            render: (content,key) =>{
                return <DialogCollapseSection title={"Farmer Info"} key={key} initiallyOpen={sections.farmerInfo}>
                    {content}
                </DialogCollapseSection>
            }
        },
        {
            group: paymentInfo,
            render: (content,key) =>{

                return <DialogCollapseSection title={"Payment"} key={key} initiallyOpen={sections.payment}>
                    {content}
                </DialogCollapseSection>
            }
        }

    ];

}

export const TimeRangeInfo = {

    "today": {
        label: <span><Icon icon={ic_date_range}/> Today</span>,
        text: "Today"
    },
    "yesterday": {
        label: <span><Icon icon={ic_view_day }/> Yesterday</span>,
        text: "Yesterday"
    },
    "week": {
        label: <span><Icon icon={ic_view_week}/> This Week</span>,
        text: "This Week"
    },
    "month": {
        label: <span><Icon icon={ic_date_range}/> This Month</span>,
        text: "This Month"
    },
    "year": {
        label: <span><Icon icon={ic_date_range}/> This Year</span>,
        text: "This Year"
    },
    "custom": {
        label: <span><i className="fa fa-gear"/> Custom</span>,
        text: "Custom"
    }
};


export { renderInputs  , renderStatus , detectPhoneOperator }


// WEBPACK FOOTER //
// ./src/views/Request/RequestCommon.js